;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('toggle', ToggleDirective)

  ToggleDirectiveController.$inject = []
  function ToggleDirectiveController () {

  }

  ToggleDirective.$inject = []
  function ToggleDirective () {
    return {
      restrict: 'E',
      scope: {
      },
      bindToController: {
        change: '=',
        model: '=',
        color: '@'
      },
      controller: ToggleDirectiveController,
      controllerAs: 'input',
      templateUrl: '/app/common/directives/toggle/toggle.html'
    }
  }
})(window.angular)
